import axios from 'axios'
import { snackBarBus } from '../main'
import { generalMixin } from './general'
import { authMixin } from './auth'

export const adminMixin = {
  mixins: [generalMixin, authMixin],
  methods: {
    admin_loginAs(usrId, wantedCmpId = 0) {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      //post data to API
      let postData = {
        //post agentData in order to return specific data depending on "who's watching"
        usrId: usrId
      }
      if (wantedCmpId != 0) {
        postData.wantedCmpId = wantedCmpId
      }
      let url = this.url_composeApiUrl('/admin/login-as')
      console.log('post', url)
      axios.post(url, postData, config)
        .then(response => {
          console.log('response', response)
          if (response.data.success) {
            this.auth_onAuth(response.data.returnData.access_token, response.data.returnData.loggedInData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    }
  }
}
